import * as Yup from 'yup';

import { FIELD_TYPES, VALIDATION_MESSAGES } from './constants';

export const toStrCamelCase = str => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join('');
};

export const toCamelCase = obj => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      let camelKey = key
        .replace(/\s(.)/g, match => match.toUpperCase())
        .replace(/\s/g, '')
        .replace(/^(.)/, match => match.toLowerCase());
      return [camelKey, value];
    })
  );
};

export const toSnakeCase = obj => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      let snakeKey = key.toLowerCase().replace(/\s+/g, '_');
      return [snakeKey, value];
    })
  );
};

export const capitalizeText = text => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const getFileNameFromUrl = url => {
  if (typeof url !== 'string') return '';

  const fileName = url.split('/').pop()?.split('?')[0] || '';
  const dotIndex = fileName.lastIndexOf('.');
  const underscoreIndex = fileName.lastIndexOf('_');

  if (dotIndex === -1 || underscoreIndex === -1) return fileName;

  const name = fileName.slice(0, underscoreIndex);
  const extension = fileName.slice(dotIndex);

  return `${name}${extension}`;
};

export const replaceWhiteSpaceWithUnderscore = str => {
  return str.replace(/\s+/g, '_');
};

export const getSelectPickerValue = (label, isMultiSelect, fieldItems, values) => {
  if (isMultiSelect) {
    return values?.[label] || [];
  }

  return fieldItems.find(item => item.label === values?.[label]);
};

export const getFieldPlaceholder = (fieldType, label, isProcessingFiles) => {
  const isFile = fieldType === FIELD_TYPES.UPLOAD;

  if (isFile && isProcessingFiles) return 'Uploading...';

  return capitalizeText(label);
};

export const generateValidationSchema = fields => {
  const schema = {};
  fields?.forEach(({ label, type, isRequired, isMultiSelect }) => {
    if (!label) return;
    const fieldType = type?.toLowerCase();
    let validator;

    if (fieldType === FIELD_TYPES.DROPDOWN && isMultiSelect) {
      validator = Yup.array()
        .of(Yup.string())
        .test(
          'nonEmptyArray',
          VALIDATION_MESSAGES.REQUIRED,
          value => !isRequired || (Array.isArray(value) && value.length > 0)
        );
    } else {
      switch (fieldType) {
      case FIELD_TYPES.EMAIL:
        validator = Yup.string().email(VALIDATION_MESSAGES.INVALID_EMAIL);
        break;
      case FIELD_TYPES.NUMBER:
        validator = Yup.string().matches(/^\d+$/, VALIDATION_MESSAGES.NUMERIC_ONLY);
        break;
      case FIELD_TYPES.UPLOAD:
        validator = Yup.mixed().test(
          'fileRequired',
          VALIDATION_MESSAGES.REQUIRED,
          value => !isRequired || (value && value.length > 0)
        );
        break;
      default:
        validator = Yup.string();
      }

      if (isRequired && fieldType !== FIELD_TYPES.UPLOAD) {
        validator = validator.required(VALIDATION_MESSAGES.REQUIRED);
      }
    }

    schema[label] = validator;
  });
  return Yup.object().shape(schema);
};

export const truncateText = (text, maxLength = 30) => {
  if (!text || text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
};
